import React from 'react';
import {useAuth} from "../../context/AuthContext";
import {useLang} from "../../context/LanguageContext";
import {useNavigate} from "react-router-dom";


const CardMyAccount = () => {
    const {currentUser, userName} = useAuth();
    const {t} = useLang();
    const navigate = useNavigate();


    if(!currentUser){
        return (
            <div className="max-w-[95vw] md:max-w-[800px] mx-auto my-4 space-y-2">
                <div
                    onClick={() => navigate('/login')}
                    className="bg-[#34495e] border-2 border-[#2ecc71] rounded-[10px] flex items-center justify-center p-2 cursor-pointer h-[50px]"
                >
                    <div className="flex items-center flex-col text-white mr-4">
                        <span className="font-medium">{t("btn.login")}</span>
                    </div>
                </div>
                <div
                    onClick={() => navigate('/register')}
                    className="bg-[#34495e] border-2 border-[#27ae60] rounded-[10px] flex items-center justify-center p-2 cursor-pointer h-[50px]"
                >
                    <div className="flex items-center flex-col text-white mr-4">
                        <span className="font-medium">{t("btn.register")}</span>
                    </div>
                </div>
            </div>
        );
    }


    return (
      <div 
        onClick={() => navigate('/account')}
        className="max-w-[95vw] md:max-w-[800px] mx-auto my-4 bg-[#34495e] border-2 border-[#2ecc71] rounded-[10px] flex items-center justify-center p-2 cursor-pointer h-[50px]"
      >
        <div className="flex items-center flex-col text-white mr-4">
          <span className="font-medium">{t("btn.myAccount")}</span>
          <span className="text-sm font-light">{userName}</span>
        </div>
      </div>
    );
  };
  
  export default CardMyAccount;